import React, { useEffect, useState } from "react";
import Select from "react-select";
import Modal from "react-modal";
import ActivityForm from "./activity-form";

import "./navbar2.css";
import "../app/app.css";
import "../../static/css/fontawesome-all.css";

import { Navbar, Nav } from "react-bootstrap";
import { ReactComponent as AddSvg } from '../assets/i_plus_activity.svg';

import { createGpxURL,
  racePlansURL,
  guideHowtosURL,
  profileURL,
  pricingURL,
  loginURL,
  logoutURL,
  registerURL,
  logoURL,
  gettingStartedURL,
 } from "../../services/links";

// import { useUserContext } from "../app"; 
// TODO: Move to a css
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    width: "90%",
    maxWidth: "650px",
    transform: "translate(-50%, -50%)",
    zIndex: "99999",
    padding: "1rem",
    paddingTop: "30px",
    border: "0px solid #014D72",
    background: "transparent",
  },
};

Modal.setAppElement("#root");

// ====== Beginning of the component
const Navbar2 = ({
  listOfActivities,
  trails,
  onChange,
  userStripeLevel,
  isUserLoggedIn,
  handleActivityAdd,
  selectedActivity,
}) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState();
  const [currentOpt, setCurrentOpt] = useState(null);
  const [menuStatus, setMenuStatus] = useState(false);
  const [subscribeBtnText, setSubscribeBtnText] = useState("UPGRADE");
  const [subscribeBtnClass, setSubscribeBtnClass] = useState("resp-nav-sa-link nav__upgrade__link nav__upgrade__link--free");

  useEffect(() => {
    // console.log("Navbar2: Debug: Update list of activities in navbar");
    const newOptions = listOfActivities
      ? listOfActivities.map((activity) => {
          return {
            value: activity.id,
            label: activity.title,
            trail: activity.trackId,
            uuid: activity.uuid,
          };
        })
      : null;
    setOptions(newOptions);
  }, [listOfActivities]);

  useEffect(() => {
    // console.log("Navbar2: Debug: Update the current option: " + selectedActivity);
    if (options) {
      let currentOption = options.filter(
        (option) => option.value === selectedActivity
      );
      setCurrentOpt(currentOption);
    }
  }, [selectedActivity, options]);

  useEffect(() => {
    // If user free, return different class and button text
    if (userStripeLevel === "free") {
      setSubscribeBtnText("Free Trial");
      setSubscribeBtnClass("resp-nav-sa-link nav__upgrade__link nav__upgrade__link--free");
    } else {
      setSubscribeBtnText(userStripeLevel);
      setSubscribeBtnClass("resp-nav-sa-link nav__upgrade__link");
    }
  }, [userStripeLevel]);

  function openModal() {
    setIsOpen(true);
  }

  const closeModal = () => {
    setIsOpen(false);
  };

  const toggleMenuHandler = () => {
    setMenuStatus(!menuStatus);
  };

  return (
    <>
      <Navbar
        className="resp-nav-sa"
        collapseOnSelect
        expand="lg"
        variant="light"
        onToggle={toggleMenuHandler}
        expanded={menuStatus}>
        <Navbar.Brand href="/">
          <img
            src={logoURL}
            height="28px"
            padding-left="5px"
            alt="waldup"
            className="d-inline-block align-center"
          ></img>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            {isUserLoggedIn && (
              <div className="select-bar">
                <Select
                  placeholder="Search"
                  onChange={(e) => {
                    setMenuStatus(!menuStatus);
                    onChange(e);
                  }}
                  options={options}
                  className="select-box"
                  value={currentOpt}
                  styles={navBarCustomStyles}
                />
                <button
                  className="btn btn-light add-activity-btn"
                  onClick={openModal}
                >
                  <AddSvg
                    style={{ paddingRight: "5px" , color: "#004469"}}
                  />
                  New Activity
                </button>
              </div>
            )}
          </Nav>
          {isUserLoggedIn && (
            <Nav>
              <Nav.Link className="resp-nav-sa-link" href={createGpxURL}>
                Create Track
              </Nav.Link>
              <Nav.Link className="resp-nav-sa-link" href={racePlansURL}>
                Race Plans
              </Nav.Link>
              <Nav.Link className="resp-nav-sa-link" href={guideHowtosURL}>
                Guides
              </Nav.Link>
              <Nav.Link
                className="resp-nav-sa-link"
                href={profileURL}
              >
                Profile
              </Nav.Link>
              <Nav.Link
                className={subscribeBtnClass}
                href={pricingURL}
                style={{color: "white"}}
              >
                {subscribeBtnText}
              </Nav.Link>
              <Nav.Link
                className="resp-nav-sa-link-login"
                href={logoutURL}
              >
                Sign Out
              </Nav.Link>
            </Nav>
          )}
          {!isUserLoggedIn && (
            <Nav>
              <Nav.Link className="resp-nav-sa-link nav__upgrade__link--free-inv" 
              href={pricingURL}
              style={{color: "#AA1939"}}
              >
                Free Trial
              </Nav.Link>
              <Nav.Link className="resp-nav-sa-link" href={gettingStartedURL}>
                Getting Started
              </Nav.Link>
              <Nav.Link className="resp-nav-sa-link" href={racePlansURL}>
                Race Plans
              </Nav.Link>
              <Nav.Link className="resp-nav-sa-link" href={guideHowtosURL}>
                Guides
              </Nav.Link>
              <Nav.Link
                className="resp-nav-sa-link-login"
                href={loginURL}
              >
                Sign In
              </Nav.Link>
              <Nav.Link
                className="resp-nav-share-link__register"
                href={registerURL}
              >
                Sign Up Free
              </Nav.Link>
            </Nav>
          )}
        </Navbar.Collapse>
      </Navbar>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        className="Modal"
        overlayClassName="Overlay"
      >
        <ActivityForm
          trails={trails}
          handleActivityAdd={handleActivityAdd}
          closeModal={closeModal}
        />
      </Modal>
    </>
  );
};

const navBarCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    background: "#FFFFFF",
    color: "#BDBDBD",
    borderColor: "#BDBDBD",
    borderRadius: "10px",
    fontWeight: "400",
    fontSize: "12px",
  }),
  option: (provided, state) => ({
    ...provided,
    color: "#212529",
    background: state.isFocused ? "039EDB" : "aliceblue",
    fontWeight: "400",
    fontSize: "12px",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#212529",
    fontWeight: "400",
    fontSize: "12px",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: "#212529",
  }),
};

export default Navbar2;